module.exports = __webpack_public_path__ + "static/img/appointmentbot.31f6f68.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/appointmentbot.gif
// module id = oqkF
// module chunks = 0